import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-32d717f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-center text-wrap modal-header",
  "data-test": "team-invite-modal-title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "invite-control-container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  class: "row",
  style: {"margin-top":"20px"}
}
const _hoisted_6 = { class: "col-sm-12 text-center modal-button-container" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger text-center",
  "data-test": "team-invite-modal-error"
}
const _hoisted_8 = {
  key: 0,
  class: "col-sm-10 col-sm-offset-1 text-big"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You do not have permission to invite to this team", -1))
const _hoisted_10 = [
  _hoisted_9
]

import { Modal } from "uiv";
import { computed, inject, onMounted, Ref, ref } from "vue";
import axios from "axios";
import { debug } from "debug";
import {
  ChargebeeSubscriptionApiModel,
  InviteControlApiModel,
  TeamApiModel,
  TeamSettingsApiModel,
} from "../../api-models";
import { GroupInviteModel } from "../../views/team/team-invite.vue";
import TeamInviteControl from "./team-invite-control.vue";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-invite-modal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["close-modal"],
  setup(__props: any, { emit: __emit }) {

const team = inject("teamModel") as Ref<TeamApiModel>;
const settings = inject("teamSettingsModel") as Ref<TeamSettingsApiModel>;

const props = __props;
const emit = __emit;

const isDisplayed = computed(() => {
  return props.modelValue;
});

const isLoading = ref(true);
const errorMessage = ref<string | null>(null);

const model = ref<InviteControlApiModel | null>(null);
const subscriptionModel = ref<ChargebeeSubscriptionApiModel | null>(null);
const seats = ref<{ totalSeats: number; seatsInUse: number; availableSeats: number } | null>(null);

const canInvite = computed(() => {
  return settings.value.userPermissions.canInviteToGroup;
});

const isLicenceHolder = computed(() => {
  return csContext.userProfile.hasLicence;
});

function closeModal(triggerRefresh: boolean) {
  emit("close-modal", triggerRefresh);
}

const isLevelCompletable = ref(false);

function markLevelAsCompletable() {
  if (!isLevelCompletable.value) {
    isLevelCompletable.value = true;
  }
}

async function loadSubscription(): Promise<void> {
  return axios.get("/api/subscription/default").then((resp) => {
    const subModel = resp.data as ChargebeeSubscriptionApiModel | null;
    if (subModel) {
      subscriptionModel.value = subModel;
      seats.value = {
        totalSeats: subModel.currentPaidLicenceCount,
        seatsInUse: subModel.licences.length,
        availableSeats: subModel.currentPaidLicenceCount - subModel.licences.length,
      };
    }
  });
}

async function loadInviteModel(): Promise<void> {
  return axios.get(`/team/invitemodel/${team.value.id}`).then((resp) => {
    const inviteModel = resp.data as GroupInviteModel;
    const controlModel = inviteModel.invites;
    controlModel.sendUrl = `/invitecodes/sendgroupinvites/${team.value.id}`;
    controlModel.peoplePhrase = inviteModel.groupName;
    debug(inviteModel.groupName);
    model.value = controlModel;
  });
}

function loadData() {
  const axiosPromises: Promise<void>[] = [];
  axiosPromises.push(loadInviteModel());
  axiosPromises.push(loadSubscription());

  Promise.all(axiosPromises).then(() => {
    isLoading.value = false;
  });
}

onMounted(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  return (model.value && _unref(team))
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: isDisplayed.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isDisplayed).value = $event)),
        size: "lg",
        footer: false,
        backdrop: true
      }, {
        header: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, [
            _createTextVNode(" Invite team members to "),
            _hoisted_2,
            _createTextVNode("'" + _toDisplayString(_unref(team).name) + "' ", 1)
          ]),
          _createElementVNode("button", {
            class: "btn btn-close-sm btn-position",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(false))),
            type: "button"
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (!isLicenceHolder.value || canInvite.value)
              ? (_openBlock(), _createBlock(TeamInviteControl, {
                  key: 0,
                  model: model.value,
                  onInviteAction: markLevelAsCompletable,
                  onPreviousInvites: markLevelAsCompletable,
                  onOnDeletedEvent: loadInviteModel
                }, null, 8, ["model"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, [
            _createTextVNode(" You can invite more team members at any time from the "),
            _createElementVNode("a", {
              href: `/team/members/${_unref(team).id}`
            }, "Team Members", 8, _hoisted_4),
            _createTextVNode(" page. ")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-default-close",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (closeModal(false))),
                "data-test": "team-invite-modal-close-button"
              }, " Close ")
            ]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true)
          ]),
          (isLicenceHolder.value && !canInvite.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})